import React, { FC } from 'react'
import { PushMessageType } from 'types/pushMessage'
import equal from 'fast-deep-equal'
import { StaffPushMessageCard } from 'components/Card'
import styles from 'styles/components/list.module.scss'

type Props = {
  pushMessages: PushMessageType[]
}

const StaffPushMessageCardList: FC<Props> = React.memo(
  (props) => {
    const { pushMessages } = props
    return (
      <ul className={styles.push_message__list}>
        {pushMessages.map((pushMessage) => (
          <StaffPushMessageCard key={pushMessage.id} pushMessage={pushMessage} />
        ))}
      </ul>
    )
  },
  (prev, next) => equal(prev, next)
)

export default StaffPushMessageCardList
